import styled from 'styled-components';

import { COLOR_RED, COLOR_ORANGE, COLOR_BLACK } from '../../../assets/styles/colors';

export const CheckboxWrapSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CheckboxSC = styled.label`
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  width: fit-content;

  input {
    display: none;
  }

  .ch-circle,
  .ch-label {
    display: inline-block;
    vertical-align: middle;
  }

  .ch-label {
    font-size: 18px;
    color: ${({ theme }) => COLOR_BLACK};

    ${({ type, theme }) => {
      if (type === 'DISABLED') {
        return 'color: rgba(47,46,65,0.2);';
      }
      if (type === 'READONLY') {
        return 'color: rgba(47,46,65,0.5)';
      }
      if (type === 'ERROR') {
        return `color: ${COLOR_RED};`;
      }
    }}
  }

  .ch-circle {
    position: relative;
    min-width: 24px;
    min-height: 24px;
    height: 24px;
    width: 24px;
    border: none;
    border-radius: 8px;

    &:not(.no-label) {
      margin-right: 14px;
    }

    text-align: center;
    border: 1px solid rgba(63, 61, 86, 0.2);
    transition: all 0.2s;

    ${({ active, type, theme }) => {
      if (active) {
        return `
        border-color: ${COLOR_ORANGE};
        &:after {
          background: ${COLOR_ORANGE};
        }`;
      }
    }}
  }

  .ch-inner {
    height: 16px;
    width: 16px;
    border-radius: 6px;
    margin: 3px;
    scale: 0;
    transition: all 0.2s;

    ${({ active, type, theme }) => {
      if (active) {
        return `
        background: ${COLOR_ORANGE};
        scale:1;
        `;
      }
    }};
  }
`;
